export default {
  isEmpty: (state) => !state.overviewData
}
